import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroBoletosRecebidos } from '@/features/relatorio/page/financeiro/boletos-recebidos/RelatorioFinanceiroBoletosRecebidos';

export const Route = createFileRoute('/a/relatorio/financeiro/boletos-recebidos')({
    component: RelatorioFinanceiroBoletosRecebidos,
});
